import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const bureauApi = createApi({
  reducerPath: "bureauApi",
  baseQuery: fetchBaseQuery({
    // baseUrl:'http://localhost:8000/api/bureaus'
    baseUrl: process.env.REACT_APP_BASE_URL,
    credentials: 'include',
  }),
  tagTypes: ["Bureaus"],
  keepUnusedDataFor: 60,
  endpoints: (builder) => ({
    getAllBureaus: builder.query({
      query: () => ({ url: "/bureaus" }),
      providesTags: ["Bureaus"],
    }),
    getBureau: builder.query({
      query: (id) => ({ url: `/bureaus/${id}` }),
      providesTags: ["Bureaus"],
    }),

    getBureauAdmins: builder.query({
      query: (bureauId) => ({
        url: `/bureaux/${bureauId}/admins`,
        method: "GET",
      }),
      providesTags: (result, error, bureauId) => [
        { type: "Bureaus", id: bureauId },
      ],
    }),

    attachAdminToBureau: builder.mutation({
      query: ({ bureauId, userId }) => ({
        url: `/bureaux/${bureauId}/attachadmin/${userId}`,
        method: "POST",
      }),
      invalidatesTags: (result, error, { bureauId }) => [
        { type: "Bureaus", id: bureauId },
      ],
    }),

    detachAdminFromBureau: builder.mutation({
      query: ({ bureauId, userId }) => ({
        url: `/bureaux/${bureauId}/detachadmin/${userId}`,
        method: "POST",
      }),
      invalidatesTags: (result, error, { bureauId }) => [
        { type: "Bureaus", id: bureauId },
      ],  
    }),
    updateBureau: builder.mutation({
      query: ({ id, bureau }) => ({
        url: `/bureaus/${id}/update`,
        method: 'POST', 
        body: bureau,
      }),
      invalidatesTags: ['Bureaus'],
    }),

    addBureau: builder.mutation({
      query: (body) => ({
        url: "/bureaus",
        method: "POST",
        body,
      }),
      providesTags: ["Bureaus"],
    }),
  }),
});
export const {
  useGetAllBureausQuery,
  useGetBureauQuery,
  useAddBureauMutation,
  useGetBureauAdminsQuery,
  useAttachAdminToBureauMutation,
  useDetachAdminFromBureauMutation,
  useUpdateBureauMutation,
} = bureauApi;
